import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch } from '../modules/utility';
import { showErrors } from '../modules/general';

const getGeoTabGroupCollection = ({ callback = _.noop } = {}) => (dispatch) => {
	apiFetch({ method: 'admin.getGeoTabGroupCollection', params: {}, dispatch, callback });
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ getGeoTabGroupCollection, showErrors }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps);
